module.exports = __webpack_public_path__ + "img/flechader3.bee04592.png";